import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: () => import('../views/Home.vue'),
    meta: {
      title: 'TJH - Ticket Job Hub'
    }
  },
  {
    path: '/jobs',
    name: 'jobs',
    component: () => import('../views/jobs.vue'),
    meta: {
      title: 'TJH - Ticket Job Hub'
    }
  },
  {
    path: '/Companies',
    name: 'Companies',
    component: () => import('../views/Companies.vue'),
    meta: {
      title: 'TJH - Ticket Job Hub'
    }
  },
  {
    path: '/About',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      title: 'TJH - Ticket Job Hub'
    }
  },
  {
    path: '/Contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
    meta: {
      title: 'TJH - Ticket Job Hub'
    }
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  // 添加滚动行为
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title
  next()
})

export default router